import axios from "../axios";

export async function sendCustomEmail(values) {
  let response = null;
  try {
    response = await axios.post("/custom-email", {
      ...values
    });
  } catch (e) {
    console.log("error", e);
  }
  return response;
}
